import React from 'react';
import { AuthProvider } from '../context/AuthProvider';
import { FilesProvider } from '../context/FilesProvider';
import ModalComponent from '../components/modal/Modal';
import { Toaster } from 'react-hot-toast';

const Modal = () => {
  return (
    <AuthProvider>
      <FilesProvider>
        <Toaster position="top-center" reverseOrder={false} />
        <ModalComponent />
      </FilesProvider>
    </AuthProvider>
  );
};

export default Modal;
